import { Mail } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import type { Folder } from '@/hooks/useFolders';
import { cn } from '@/lib/utils';

interface CorrespondenceFolderIndicatorProps {
  folder: Folder;
  className?: string;
  variant?: 'inline' | 'badge';
}

/** A quiet, reusable marker for folders that are Correspondence sources. */
export function CorrespondenceFolderIndicator({
  folder,
  className,
  variant = 'inline',
}: CorrespondenceFolderIndicatorProps) {
  if (!folder.is_correspondence) return null;

  const isBadge = variant === 'badge';

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={cn(
              isBadge
                ? 'absolute -bottom-0.5 -right-1 inline-flex h-2.5 w-2.5 shrink-0 items-center justify-center rounded-[3px] bg-white text-slate-400 ring-1 ring-white'
                : 'inline-flex shrink-0 translate-y-px items-center text-gray-400',
              className,
            )}
            role="img"
            aria-label="Correspondence folder"
          >
            <Mail className={isBadge ? 'h-2.5 w-2.5' : 'h-3.5 w-3.5'} aria-hidden="true" />
          </span>
        </TooltipTrigger>
        <TooltipContent side="top">Correspondence folder</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
